import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-indigo-100 via-purple-100 to-pink-100">
      <div className="py-4 w-full border-t border-indigo-200 text-center">
        <p className="text-indigo-700 font-medium tracking-wide text-sm font-serif">
          © 2025 Library App. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
